import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_VC6: TStep[] = [
  {
    pageId: PageId.SEX_VC6,
  },
  {
    pageId: PageId.DOG_AGE_VC6,
  },
  {
    pageId: PageId.SHELTER_VC6,
  },
  {
    pageId: PageId.DOG_BREED_VC6,
  },
  {
    pageId: PageId.BEHAVIOR_VC6,
  },
  {
    pageId: PageId.HEALTH_ISSUES_VC6,
  },
  {
    pageId: PageId.GOALS_QUESTION_VC6,
  },
  {
    pageId: PageId.URGE_VC6,
  },
  {
    pageId: PageId.FEED_VC6,
  },
  {
    pageId: PageId.WALK_VC6,
  },
  {
    pageId: PageId.STRESS_VC6,
  },
  {
    pageId: PageId.HOME_ALONG_VC6,
  },
  {
    pageId: PageId.ACTIVITY_VC6,
  },
  {
    pageId: PageId.DESCRIBE_VC6,
  },
  {
    pageId: PageId.ALMOST_DONE_VC6,
  },
  {
    pageId: PageId.TRAINER_IS_READY_VC6,
  },
  {
    pageId: PageId.DOG_SUMMARY_VC6,
  },
  {
    pageId: PageId.FEATURE_DESCRIPTION_VC6,
  },
  {
    pageId: PageId.CYNOLOGISTS_VC6,
  },
  {
    pageId: PageId.OUR_MISSION_VC6,
  },
  {
    pageId: PageId.LIMITED_OFFER_VC6,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_TRIAL_PRICE_VC6,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_TRIAL_PRICE_2_VC6,
  },
  {
    pageId: PageId.CALENDLY_VC6,
  },
  {
    pageId: PageId.ALL_SET_VC6,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_VC6.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_VC6.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
